import styled from '@emotion/styled';
import { colorPalettes, Flex } from '@linearb/linui-common';

const SlashLine = styled.div`
  border-right: 2px solid
    ${({ theme }) =>
      colorPalettes[theme.palette.mode].background.backgroundElements};
  transform: skew(-14deg);
`;

export const LinesContainer = styled(Flex)`
  ${SlashLine} {
    &:first-child {
      margin-left: 22rem;
    }
    &:nth-child(3) {
      margin-left: -1rem;
    }
    height: 100%;
    margin-right: 10rem;
  }
`;

const SlashLines = () => {
  return (
    <LinesContainer>
      <SlashLine />
      <SlashLine />
      <SlashLine />
      <SlashLine />
    </LinesContainer>
  );
};
export default styled(SlashLines)``;
